/**
 * Convert a Webfleet millidegree coordinate integer to a standard decimal-degree value.
 *
 * Webfleet encodes latitude and longitude as integers in millidegrees (1e-6 degrees per unit).
 * This function divides by 1,000,000 to produce the decimal-degree value expected by mapping
 * APIs. Returns 0 when the input is null, undefined, or 0.
 *
 * @param mdeg - Coordinate in millidegrees as returned by the Webfleet API.
 * @returns Decimal-degree coordinate, or 0 if the input is absent.
 */
export function getWebfleetCoordinateValue(mdeg: number | null | undefined): number {
	if (!mdeg) return 0;
	return mdeg / 1e6;
}
